<template>
  <div class="login">
    <div class="header">
      <h4 >Partner Portal</h4>
      <h2 v-if="partner">{{ partner.name }}</h2>
      <h2 v-else><em class="el-icon-loading"></em></h2>
    </div>
    <el-card>
      <h2>Login</h2>
      <el-form class="login-form" :model="model" :rules="rules" ref="form">
        <el-form-item prop="email">
          <el-input v-model="model.email" placeholder="Email" prefix-icon="fas fa-user"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="model.password"
            placeholder="Password"
             @keyup.enter.native="submit($event)"
            type="password"
            prefix-icon="fas fa-lock"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="status.loggingIn"
            class="login-button"
            type="primary"
            @click="submit($event)"
            block
          >Login</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "login",
  data() {
    return {
      model: {
        email: "",
        password: ""
      },
      rules: {
        email: [
          {
            required: true,
            message: "Email is required",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "Password is required", trigger: "blur" }
        ]
      }
    };
  },
  created() {
  },
  computed: {
    ...mapState("account", ["status","partner"])
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    async submit(event) {
      event.preventDefault();
      let valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      } else {
        this.login({ email: this.model.email, password: this.model.password });
      }
    }
  }
};
</script>
<style scoped>

.header{
  margin-top:100px
}
.login {
  background: #f7f7f7;
  padding-left:100px;
  flex: 1;
  display: flex;
  flex-direction: column;
    background: rgb(238, 237, 234);
    min-height: 100vh;

}

.login-button {
  width: 100%;
  margin-top: 40px;
}
.login-form {
  width: 290px;
}
.forgot-password {
  margin-top: 10px;
}
</style>
<style lang="scss">
.login .el-input__prefix {
  left: 0;
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: 3px;
  .el-input__icon {
    width: 30px;
  }
}
.login .el-input input {
  padding-left: 35px;
}
.login .el-card {
  padding-top: 0;
  padding-bottom: 30px;
}
h2 {
  font-family: "Open Sans";
  letter-spacing: 1px;
  font-family: Roboto, sans-serif;
  padding-bottom: 20px;
}
// a {
//   color: $teal;
//   text-decoration: none;
//   &:hover,
//   &:active,
//   &:focus {
//     color: lighten($teal, 7);
//   }
// }
.login .el-card {
  width: 400px;
  display: flex;
  justify-content: center;
}
</style>
